import { PRODUCT_FAMILY_ID } from './consts';
export function isCoreProduct(product) {
  return product !== null && product !== undefined && 'name' in product && 'productId' in product && product.productFamilyId === PRODUCT_FAMILY_ID;
}
//# sourceMappingURL=types.js.map